(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
(() => {
  function initShippingProgress() {
    const host = document.querySelector('[data-ls-shipping-host]');
    if (!host || host.dataset.ready) return;
    host.dataset.ready = 'true';
    const form = host.closest('form');
    const footer = document.getElementById('CartFooter');
    const products = document.getElementById('CartProducts');
    if (!form || !footer || !products) return;
    let sequence = 0;
    let timer;
    let controller;
    let estimatorChanged = false;
    function hidePending() {
      host.hidden = true;
      sequence++;
      clearTimeout(timer);
      if (controller) controller.abort();
    }
    function refresh() {
      hidePending();
      if (estimatorChanged) return;
      const current = sequence;
      timer = setTimeout(async () => {
        controller = new AbortController();
        const deadline = setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(host.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', host.dataset.section);
          const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if (!response.ok) throw new Error('Cart unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.getElementById(host.id);
          if (current !== sequence || !host.isConnected || !next) return;
          const rendered = Array.from(html.querySelectorAll('#CartProducts input[name="updates[]"]')).map(el => [el.id, el.value]);
          const shown = Array.from(products.querySelectorAll('input[name="updates[]"]')).map(el => [el.id, el.value]);
          if (JSON.stringify(rendered) !== JSON.stringify(shown)) return;
          host.replaceChildren(...Array.from(next.childNodes));
          host.hidden = false;
        } catch (_) {
          if (current === sequence) host.hidden = true;
        } finally {
          clearTimeout(deadline);
        }
      }, 120);
    }
    form.addEventListener('input', event => {
      if (event.target.matches('input[name="updates[]"]')) hidePending();
    });
    form.addEventListener('change', event => {
      if (event.target.matches('input[name="updates[]"]')) hidePending();
    });
    form.addEventListener('click', event => {
      if (event.target.closest('.js-qty__adjust, .remove-item')) hidePending();
    }, true);
    new MutationObserver(refresh).observe(footer, {childList:true,subtree:true,characterData:true});
    new MutationObserver(refresh).observe(products, {childList:true,subtree:true});
    window.addEventListener('pageshow', event => { if(event.persisted) refresh(); });
    document.addEventListener('visibilitychange', () => { if(document.visibilityState === 'visible') refresh(); });
    const estimator = form.querySelector('#address_country');
    if (estimator) estimator.addEventListener('change', () => { estimatorChanged = true; hidePending(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShippingProgress);
  else initShippingProgress();
  document.addEventListener('shopify:section:load', initShippingProgress);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-equipment-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initFinder(root) {
    if (root.dataset.ready) return;
    const selects = Array.from(root.querySelectorAll('select[data-level]'));
    const brandField = selects[1].parentElement;
    const form = root.querySelector('form');
    const button = root.querySelector('button[type="submit"]');
    const status = root.querySelector('[data-status]');
    const nodes = Array.from(root.querySelector('template').content.querySelectorAll('a')).map(a => ({key:a.dataset.key,parent:a.dataset.parent,title:a.textContent.trim(),url:a.getAttribute('href')}));
    function path(url) {
      try {
        const u = new URL(url, window.location.href);
        if (!['http:', 'https:'].includes(u.protocol) || ![window.location.origin, 'https://lovelystickers.com'].includes(u.origin)) return '';
        return u.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, '').replace(/\/$/, '');
      } catch (_) { return ''; }
    }
    const families = Array.from(root.querySelectorAll('[data-family]')).map(a => ({key:a.dataset.family,title:a.textContent.trim(),path:path(a.getAttribute('href')),grouping:a.dataset.grouping}));
    function brandNames(node, group) {
      return [(group || node).title.replace(/\s+(wheels?|bases?|skins|stickers)$/i, '').trim()];
    }
    const children = key => nodes.filter(n => n.parent === key);
    const entries = [];
    families.forEach(family => {
      const branch = nodes.find(n => !n.parent && path(n.url) === family.path);
      if (!branch) return;
      function visit(node, group, ancestors, depth) {
        if (depth > 3 || /^(all|view all|shop all|tout|tous)(\b|$)/i.test(node.title)) return;
        const nested = children(node.key);
        if (nested.length) { nested.forEach(n => visit(n, group || node, ancestors.concat(path(node.url)), depth+1)); return; }
        const destination = path(node.url);
        if (!/^\/collections\/[^/]+$/.test(destination) || ancestors.includes(destination)) return;
        (family.grouping === 'direct' ? [family.title] : brandNames(node,group)).forEach(brand => {
          if (!brand || entries.some(e => e.family === family.key && e.brand === brand && e.path === destination)) return;
          const title = group && /^(Base|Original Wheel)$/i.test(node.title) ? group.title+' — '+node.title : node.title;
          entries.push({family:family.key,brand,title,url:node.url,path:destination});
        });
      }
      children(branch.key).forEach(n => visit(n,null,[family.path],1));
    });
    if (!entries.length) return;
    root.dataset.ready = 'true';
    let target = null;
    function reset(level) {
      for (let i=level;i<selects.length;i++) {
        selects[i].replaceChildren(new Option(selects[i].dataset.placeholder,''));
        selects[i].disabled = true;
      }
      target=null;button.disabled=true;status.textContent='';
    }
    selects[0].addEventListener('change', () => {
      reset(1);
      Array.from(new Set(entries.filter(e => e.family===selects[0].value).map(e => e.brand))).forEach(b => selects[1].add(new Option(b,b)));
      selects[1].disabled=selects[1].options.length<2;
      const direct = families.find(f => f.key === selects[0].value)?.grouping === 'direct';
      brandField.hidden = direct;
      if(direct && selects[1].options.length === 2) { selects[1].selectedIndex=1; selects[1].dispatchEvent(new Event('change')); }
    });
    selects[1].addEventListener('change', () => {
      reset(2);
      entries.filter(e => e.family===selects[0].value && e.brand===selects[1].value).forEach(e => selects[2].add(new Option(e.title,e.path)));
      selects[2].disabled=selects[2].options.length<2;
    });
    selects[2].addEventListener('change', () => {
      target=entries.find(e => e.family===selects[0].value && e.brand===selects[1].value && e.path===selects[2].value);
      button.disabled=!target;status.textContent=target ? target.title : '';
    });
    form.addEventListener('submit', event => { event.preventDefault();if(target && !button.disabled) window.location.assign(target.url); });
    reset(0);
    families.filter(f => entries.some(e => e.family===f.key)).forEach(f => selects[0].add(new Option(f.title,f.key)));
    selects[0].disabled=false;form.hidden=false;
  }
  function initAll(scope) { scope.querySelectorAll('[data-ls-finder]').forEach(initFinder); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-help-contact"]) return;
  try {
    
(() => {
  function initHelp(root) {
    if (root.dataset.helpReady) return;
    root.dataset.helpReady = 'true';
    const source = root.querySelector('[data-help-faq]');
    if (source) {
      const items = Array.from(source.querySelectorAll('.ls-faq-item'));
      if (items.length && items.every(item => item.querySelector('.ls-faq-question') && item.querySelector('.ls-faq-answer'))) {
        const list = document.createElement('div');
        list.className = 'ls-help__list';
        items.forEach(item => {
          const details = document.createElement('details');
          details.className = 'ls-help__item';
          const summary = document.createElement('summary');
          summary.textContent = item.querySelector('.ls-faq-question').textContent.trim();
          const answer = document.createElement('div');
          answer.className = 'ls-help__answer';
          Array.from(item.querySelector('.ls-faq-answer').childNodes).forEach(node => answer.append(node.cloneNode(true)));
          details.append(summary, answer);
          list.append(details);
        });
        source.replaceChildren(list);
      }
    }
    root.querySelector('.ls-help__jump')?.addEventListener('click', () => {
      root.querySelector('#ContactSupport')?.focus({preventScroll:true});
    });
    if (root.querySelector('.form-success, .ls-help__errors')) {
      root.querySelector('#ContactSupport')?.scrollIntoView();
      root.querySelector('#ContactSupport')?.focus({preventScroll:true});
    }
  }
  const initAll = scope => scope.querySelectorAll('[data-ls-help]').forEach(initHelp);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
